import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import { getFontLibrary } from '@/api'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({
        options: [],
        multiple: false,
        searchable: true,
        label: 'name',
      }),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: [],
      optionsLoaded: false,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    normalizedOptions () {
      return this.options
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.optionsLoaded) {
          this.isLoading = true
          const data = await getFontLibrary({ school: this.school }) || []
          this.options = data.map(({ id, name, path }) => ({ id, name, path }))
          this.optionsLoaded = true
          this.isLoading = false

        }
      },
    },
  },
}
